import React, { Component } from 'react';
import LinkButton from '../LinkButton';

export class Manifesting extends Component {
    static displayName = Manifesting.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
        this.history = props.history;
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        return <div className="container" >

            <div className="row mb-3 ">
                <LinkButton className="btn btn-success col-12 mb-2" to="LoadCarriers" >Create Manifest</LinkButton>
                <LinkButton className="btn btn-success col-12 mb-2" to="ManifestsInProgress" >WIP</LinkButton>
                <LinkButton className="btn btn-success col-12 mb-2" to="ManifestHistory" >History</LinkButton>
            </div>

        </div>
    }


}
